// extracted by mini-css-extract-plugin
export default {"wrapper":"m7SAq","title":"IHfQQ","param-wrapper":"bIiHD","chip":"OaxHd","questions-chip":"iTrFA","keywords-wrapper":"tqbB6"};